import { render, staticRenderFns } from "./ModalListaTermosAceite.vue?vue&type=template&id=9f1bc330&scoped=true"
import script from "./ModalListaTermosAceite.vue?vue&type=script&lang=js"
export * from "./ModalListaTermosAceite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1bc330",
  null
  
)

export default component.exports